import React, { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { PackerStatisticsBar } from "components";
import getPackerPointsInfo from "utils/packer_points";

import ErrorsModal from "./components/ErrorsModal";
import UserAdjustmentsModal from "./components/UserAdjustmentsModal";
import UserPointsModal from "./components/UserPointsModal";

const SummaryTable = ({
  data,
  packer,
  selected_date,
  today_adjustments_count,
  today_errors_count,
  today_user_points,
}) => {
  const [error_data, setErrorData] = useState(null);
  const [user_points_data, setUserPointsData] = useState(null);
  const [user_adjustment_data, setUserAdjustmentData] = useState(null);

  const total_coins_earned = Object.values(data)
    .reduce((acc, acu) => {
      return (acu?.coins_earned || 0) + acc;
    }, 0)
    .toFixed(2);

  const total_errors_count = Object.values(data).reduce((acc, acu) => {
    return (acu?.errors_count || 0) + acc;
  }, 0);

  const total_coins_lost = Object.values(data)
    .reduce((acc, acu) => {
      return (acu?.coins_lost || 0) + acc;
    }, 0)
    .toFixed(2);

  const total_user_adjustment_count = Object.values(data).reduce((acc, acu) => {
    return (acu?.user_adjustment_count || 0) + acc;
  }, 0);

  const total_user_adjustment_coins = Object.values(data)
    .reduce((acc, acu) => {
      return (acu?.user_adjustment_coins || 0) + acc;
    }, 0)
    .toFixed(2);

  const total_coins_summary = Object.values(data).reduce((acc, acu) => {
    const total_coins =
      (acu?.coins_earned || 0) -
      (acu?.coins_lost || 0) +
      (acu?.user_adjustment_coins || 0);
    return total_coins + acc;
  }, 0);

  return (
    <div className="dashboard">
      {error_data && (
        <ErrorsModal {...error_data} handleClose={() => setErrorData(null)} />
      )}
      {user_adjustment_data && (
        <UserAdjustmentsModal
          {...user_adjustment_data}
          handleClose={() => setUserAdjustmentData(null)}
        />
      )}
      {user_points_data && (
        <UserPointsModal
          {...user_points_data}
          handleClose={() => setUserPointsData(null)}
        />
      )}
      <div className="dashboard__modal-table m-t-0">
        <table>
          <tr className="sub-head">
            <th>Data</th>
            <th style={{ padding: 5 }}>Ilość godzin</th>
            <th style={{ padding: 5, width: 220 }}>Postęp</th>
            <th style={{ padding: 5 }}>Próg</th>
            <th style={{ padding: 5 }}>Punkty</th>
            <th style={{ padding: 5 }}>Błędy</th>
            <th style={{ padding: 5 }}>Uwagi</th>
            <th style={{ padding: 5 }}>Suma monet</th>
          </tr>

          {Object.keys(data).map((date) => {
            const day_sats = data[date];

            if (!day_sats) {
              const is_today = moment(date).isSame(moment(), "day");
              const is_before_2_days = moment(date).isBefore(
                moment().subtract(1, "day"),
              );

              if (is_today) {
                return (
                  <tr className="table-row">
                    <td style={{ textAlign: "center" }}>
                      <strong>{date}</strong>
                    </td>
                    <td>-</td>
                    <td style={{ padding: "5px 10px" }}>-</td>
                    <td>-</td>
                    <td>
                      {today_user_points > 0 ? (
                        <a
                          className="text-underline text-pointer"
                          onClick={() =>
                            setUserPointsData({ date, user_id: packer.id })
                          }
                        >
                          <strong>{today_user_points}</strong>
                        </a>
                      ) : (
                        <strong>-</strong>
                      )}
                    </td>

                    <td style={{ padding: 5 }}>
                      {today_errors_count ? (
                        <a
                          className="text-underline text-pointer"
                          onClick={() =>
                            setErrorData({ date, packer_id: packer.id })
                          }
                        >
                          <strong>{today_errors_count}</strong>
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {today_adjustments_count ? (
                        <a
                          className="text-underline text-pointer"
                          onClick={() =>
                            setUserAdjustmentData({
                              date,
                              packer_id: packer.id,
                            })
                          }
                        >
                          <strong>{today_adjustments_count}</strong>
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      style={{
                        padding: 5,
                      }}
                    />
                  </tr>
                );
              }
              if (is_before_2_days) {
                return (
                  <tr className="table-row">
                    <td style={{ textAlign: "center" }}>
                      <strong className="text-danger">{date}</strong>
                    </td>
                    <td colSpan={8}>
                      <strong className="text-danger">
                        Uzupełnij godziny pracy!
                      </strong>
                    </td>
                  </tr>
                );
              }
              return (
                <tr className="table-row">
                  <td style={{ textAlign: "center" }}>
                    <strong>{date}</strong>
                  </td>
                  <td>-</td>
                  <td style={{ padding: "5px 10px" }}>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td
                    style={{
                      padding: 5,
                    }}
                  >
                    <strong>-</strong>
                  </td>

                  <td
                    style={{
                      padding: 5,
                    }}
                  >
                    <strong>-</strong>
                  </td>

                  <td style={{ padding: 5 }}>
                    <strong>-</strong>
                  </td>
                </tr>
              );
            }
            const earned_points = day_sats.points;
            const worked_hours = day_sats.worked_hours;
            const coins_earned = day_sats.coins_earned || 0;
            const coins_lost = day_sats.coins_lost || 0;
            const errors_count = day_sats.errors_count || 0;
            const user_adjustment_count = day_sats.user_adjustment_count || 0;
            const user_adjustment_coins = day_sats.user_adjustment_coins || 0;
            const coins_total =
              coins_earned - coins_lost + user_adjustment_coins;
            const { level_info } = getPackerPointsInfo(
              earned_points,
              worked_hours,
            );

            return (
              <tr
                className={`table-row ${
                  selected_date === date ? "table-row--active" : ""
                }`}
                key={date}
                id={date}
                style={
                  selected_date === date ? { backgroundColor: "#f9e6a8" } : {}
                }
              >
                <td style={{ textAlign: "center" }}>
                  <strong>{date}</strong>
                </td>
                <td>{worked_hours}</td>
                <td style={{ padding: "5px 10px" }}>
                  <PackerStatisticsBar
                    show_label={false}
                    worked_hours={worked_hours}
                    packer_gauge="small"
                    value={earned_points}
                  />
                </td>
                <td>{level_info}</td>
                <td>
                  {earned_points > 0 ? (
                    <a
                      className="text-underline text-pointer"
                      onClick={() =>
                        setUserPointsData({ date, user_id: packer.id })
                      }
                    >
                      <strong>{earned_points}</strong>
                    </a>
                  ) : (
                    <strong>{earned_points}</strong>
                  )}{" "}
                  (
                  {coins_earned > 0 ? `+${coins_earned.toFixed(2)} monet` : "0"}
                  )
                </td>
                <td style={{ padding: 5 }}>
                  {errors_count > 0 ? (
                    <a
                      className="text-underline text-pointer text-danger"
                      onClick={() =>
                        setErrorData({ date, packer_id: packer.id })
                      }
                    >
                      <strong>
                        {errors_count} (
                        {coins_lost > 0
                          ? `-${coins_lost.toFixed(2)} monet`
                          : "0"}
                        )
                      </strong>
                    </a>
                  ) : (
                    <strong>-</strong>
                  )}
                </td>
                <td>
                  {user_adjustment_count > 0 ? (
                    <a
                      className={`text-underline text-pointer ${
                        user_adjustment_coins < 0
                          ? "text-danger"
                          : "text-success"
                      }`}
                      onClick={() =>
                        setUserAdjustmentData({ date, packer_id: packer.id })
                      }
                    >
                      <strong>
                        {user_adjustment_count} (
                        {user_adjustment_coins.toFixed(2)} monet)
                      </strong>
                    </a>
                  ) : (
                    "-"
                  )}
                </td>
                <td style={{ padding: 5 }}>
                  <strong
                    className={
                      coins_total > 0
                        ? `text-success`
                        : coins_total < 0
                          ? `text-danger`
                          : ""
                    }
                  >
                    {coins_total > 0
                      ? `+${coins_total.toFixed(2)}`
                      : coins_total < 0
                        ? `${coins_total.toFixed(2)}`
                        : "0.00"}
                  </strong>
                </td>
              </tr>
            );
          })}
          <tr className="table-row">
            <td style={{ textAlign: "center" }}>
              <strong>Podsumowanie</strong>
            </td>
            <td />
            <td />
            <td />
            <td>
              {total_coins_earned > 0 ? "+" : ""}
              {total_coins_earned}
            </td>
            <td style={{ padding: 5 }}>
              {total_errors_count ? (
                <strong>
                  {total_errors_count} ({total_coins_lost > 0 ? "-" : ""}
                  {total_coins_lost} monet)
                </strong>
              ) : (
                "-"
              )}
            </td>
            <td>
              {total_user_adjustment_count > 0 ? (
                <strong>
                  {total_user_adjustment_count} (
                  {total_user_adjustment_coins > 0 ? "-" : ""}
                  {total_user_adjustment_coins} monet)
                </strong>
              ) : (
                "-"
              )}
            </td>
            <td style={{ padding: 5 }}>
              <strong
                className={
                  total_coins_summary > 0
                    ? `text-success`
                    : total_coins_summary < 0
                      ? `text-danger`
                      : ""
                }
              >
                {total_coins_summary > 0
                  ? `+${total_coins_summary.toFixed(2)}`
                  : total_coins_summary < 0
                    ? `${total_coins_summary.toFixed(2)}`
                    : "0.00"}
              </strong>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default connect(
  ({
    packer_dashboard: {
      data: {
        summary: data,
        today_adjustments_count,
        today_errors_count,
        today_user_points,
      },
      packer,
    },
  }) => ({
    data,
    packer,
    today_adjustments_count,
    today_errors_count,
    today_user_points,
  }),
)(SummaryTable);
